// extracted by mini-css-extract-plugin
export default {"cls1":"PasswordFieldSet-ConfirmPassword_cls1__nb1af","cls2":"PasswordFieldSet-ConfirmPassword_cls2__RmxPc PasswordFieldSet-ConfirmPassword_cls1__nb1af"};